export const getParentAccountResponse = (response) => {
  return response?.accountLivestreams?.map((account) => {
    return {
      id: account?.id,
      value: account?.name,
      label: `${account?.name} (${account?.accountType?.name})`,
    };
  });
};

export default getParentAccountResponse;
